
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1644913660598",
    "class": "icon",
    "style": "width: 1em; height: 1em; vertical-align: inherit; fill: currentcolor; overflow: hidden;color:1777ff; font-size: 22px;",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2934",
    "width": "22",
    "height": "22",
    "data-spm-anchor-id": "a313x.7781069.0.i6"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M804 512L637.6 345.6l45.6-45.6L894.4 512h1.6v64H128v-64h676z",
        "p-id": "2935"
      }
    }
  ]
})
    }
  